import { cloneElement, type HTMLProps, type MouseEvent, type ReactElement } from 'react';
import cn from '@/utils/merge-class-names';
import type { SelectorItem } from '../symbol/symbol.type';

type Props<T> = {
  className?: string;
  flex?: boolean;
  grid?: boolean;
  items: SelectorItem[];
  itemProps?: HTMLProps<HTMLElement> & T;
  selected?: string;
  onSelect: (slug: string, index: number) => void;
  suffix?: ReactElement;
};

const selectorClass = 'cursor-pointer border-b-2 border-transparent hover:border-primary';

function Selector<T>({ className, flex = true, grid = false, items, itemProps, selected, onSelect, suffix }: Props<T>) {
  const select = (e: MouseEvent<HTMLElement>, slug: string, idx: number) => {
    e.preventDefault();
    onSelect(slug, idx);
  };

  return (
    <div className='mt-auto flex h-10 w-full'>
      {suffix && <div className='size-10' />}
      <div
        className={cn('w-full flex-1', flex ? 'flex items-center justify-center' : '', grid ? 'grid' : '', className)}>
        {items
          .filter(({ item }) => Boolean(item))
          .map(({ slug, item }, idx) =>
            cloneElement(item, {
              id: slug,
              key: slug,
              onMouseDown: (e: MouseEvent<HTMLElement>) => select(e, slug, idx),
              selected: slug === selected,
              ...itemProps,
              className: cn(selectorClass, { 'border-primary': slug === selected }, itemProps?.className),
            }),
          )}
      </div>
      {suffix &&
        cloneElement(suffix, {
          ...itemProps,
          className: cn(selectorClass, itemProps?.className),
        })}
    </div>
  );
}

export default Selector;
